// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// index.js or main.js
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loadernpm insta
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import sas from 'surfandscan'
import jquery from 'jquery'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import myI18n from './components/I18N/i18n.js'
import './main.scss'
import myConfig from './config.js'
import myStorage from './storage.js'
import myAPI from './api.js'
import myDMS from './dms.js'
// import woohooAPI from './woohoo.js'
import { ColorPicker } from 'vue-color-gradient-picker'
Vue.use(Vuex)
const store = new Vuex.Store()
Vue.use(vuexI18n.plugin, store)
Vue.use(ColorPicker)
Vue.prototype.$config = myConfig
Vue.prototype.$storage = myStorage
Vue.prototype.$sasConfig = {}
Vue.prototype.$api = myAPI
Vue.prototype.$dms = myDMS
Vue.prototype.$dms.gbl_host = Vue.prototype.$config.host + '/dms'
Vue.prototype.$dms.sas_host = Vue.prototype.$config.host
// Vue.prototype.$wapi = woohooAPI
// Vue.use(VueSweetalert2)
Vue.i18n.add('en', myI18n.translationsEn)
Vue.i18n.add('de', myI18n.translationsDe)
Vue.credentials = {}

Vue.config.productionTip = false
Vue.use(Vuetify, { theme: {
  primary: '#3271b3',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#ff9c1d'
}})
Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.use(BootstrapVue)
Vue.use(myI18n)
Vue.prototype.scanApi = new Vue({
  data: {
    name: 'scanApi',
    pageArray: [],
    scanParameter: {
      duplex: false,
      fileNamePattern: '',
      feederUnit: 0
    }
  },
  // define methods under the `methods` object
  methods: {
    updateUrl: function (sas) {
      var url = window.location.protocol + '//' + window.location.hostname
      if (window.location.port && ('' + window.location.port).length > 0) {
        url += ':' + window.location.port
      }
      // var url = 'http://' + '192.168.5.33' + ':' + '8001'
      if (Vue.prototype.$config.overrideHost) {
        url = Vue.prototype.$config.host
      }
      if (url === 'http://localhost:8080') return
      console.log(url)
      if (sas) {
        sas.token = Vue.prototype.$api.getAuthToken()
        sas.setHost(url)
      }
    },
    scan: function (parameter, onSuccess, onFailed) {
      sas.scan(onSuccess, onFailed, parameter)
    },
    getConfig: function (onSuccess, onFailed) {
      sas.getConfig(onSuccess, onFailed)
    },
    setPages: function (arr) {
      this.pageArray = arr
    },
    getPages: function () {
      return this.pageArray
    },
    getScanParameter: function () {
      return this.scanParameter
    },
    getCurrentJob: function () {
      return this.currentJob
    },
    setCurrentJob: function (currentJob) {
      this.currentJob = currentJob
      return this.currentJob
    },
    sendConfiguration: function (guid, data, onSuccess, onFailed) {
      var url = Vue.config.host + 'SimpleAdminAjax.php?type=setConfiguration&productNr=' + guid
      jquery.post(url, data, function (data) {
        onSuccess(data)
      }, 'json')
    },
    setConfiguration (data) {
      this.scanParameter[data.name] = data.value
    },
    getConfiguration: function (guid, onSuccess, onFailed) {
      var url = Vue.config.host + 'SimpleAdminAjax.php?type=getConfiguration&productNr=' + guid
      var getData = {}
      jquery.post(url, JSON.stringify(getData), function (data) {
        onSuccess(data)
      }, 'json')
    }
  }
})
Vue.prototype.scanApi.updateUrl(sas)
Vue.prototype.$eventHub.$off('setConfiguration', Vue.prototype.scanApi.setConfiguration)
Vue.prototype.$eventHub.$on('setConfiguration', Vue.prototype.scanApi.setConfiguration)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js